export default __webpack_public_path__ + "static/media/vip3.631ba8e5.webp";